import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { RouteOptions } from '../common/interfaces/common.interface';
import { ContentType } from '../enums/contentType';
import { ParentalPinComponent } from '../shared-components/parental-pin/parental-pin.component';
import { DialogService } from './dialog.service';
import { ParentalControlService } from './evergent/parental-control/parental-control.service';
import { RouteHistoryService } from './router-history.service';
import { isEpisodeType } from '../common/const/common.const';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  constructor(
    private readonly dataService: DataService,
    private readonly parentalControlService: ParentalControlService,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly routerHistoryService: RouteHistoryService
  ) {}

  async navigateToPlayerWithValidation(
    option: RouteOptions,
    onCancel?: () => void,
    forStatus?: () => void
  ) {
    const hasRating =
      option.resource.ratings?.length && option.resource.ratings[0];

    const canAccess =
      this.dataService.isParentalEnabled && hasRating
        ? await this.parentalControlService.checkParentalLevels(option.resource)
        : true;

    if (!canAccess) {
      // show parental dialog
      forStatus?.();
      this.dialogService.openDialog(ParentalPinComponent, {
        data: {
          onSuccess: () => this.navigate(option),
          onCancel: onCancel,
        },
      });
    } else {
      this.navigate(option);
    }
  }

  navigate(option: RouteOptions) {
    if (this.dataService.detailResource?.activeResource) {
      if (option.resource.contentType === ContentType.MOVIE) {
        this.dataService.detailResource = null;
      } else if (
        option.resource.contentType ===
          this.dataService.detailResource.contentType &&
        option.resource.id !== this.dataService.detailResource.activeResource.id
      ) {
        this.dataService.detailResource.activeResource = option.resource;
        if (
          isEpisodeType.includes(this.dataService.detailResource.contentType)
        ) {
          this.dataService.detailResource.resource = option.resource;
        }
      } else {
        this.dataService.detailResource.contentType = option.resource
          .contentType as ContentType;
        this.dataService.detailResource.activeResource = option.resource;
        // this.dataService.detailResource.resource = option.resource;
      }
    }
    this.dataService.selectedCardData = option.resource;

    if (option.replaceHistory) {
      this.routerHistoryService.replaceHistory(
        option.navigationPath,
        option.state
      );
    } else {
      this.router.navigate([option.navigationPath], {
        state: option.state,
      });
    }
    return;
  }
}
